import Edit from '@/views/activity_years/edit'

export default {
  path: '/activity_years',
  redirect: '/activity_years/index',
  name: 'activity_years',
  meta: {
    auth: {
      redirect: {
        name: 'activity_years.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Actividades'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'create/:activity_id',
    name: 'activity_years.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
      path: 'edit/:id',
      name: 'activity_years.edit',
      component: Edit,
      meta: {
        auth: true,
        label: 'Editar'
      }
    }]
}
